export const getPermissions = () => {
  try {
    return JSON.parse(localStorage.getItem("permissions")) || [];
  } catch {
    return [];
  }
};

// Admin is the superuser: it can reach everything in the application, and that
// does not depend on the permissions array surviving the round trip through
// login/refresh. Every OTHER role — HR included — is permission-driven, i.e. it
// sees a module only because Roles & Access Management granted it that key.
//
// This mirrors the server, which is what actually enforces access:
// middleware/checkPermission.js short-circuits for Admin the same way.
export const isAdmin = () => {
  try {
    return String(localStorage.getItem("role") || "").toLowerCase().trim() === "admin";
  } catch {
    return false;
  }
};

export const hasPermission = (permission) => {
  if (isAdmin()) return true;
  return getPermissions().includes(permission);
};

export const hasAnyPermission = (permissionList = []) => {
  if (isAdmin()) return true;
  const permissions = getPermissions();
  return permissionList.some((item) => permissions.includes(item));
};
